module.exports = __webpack_public_path__ + "media/alarm-short.002efdcc.mp3";